import * as React from "react";
function SvgTweezer(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                d="M21 4.015a1.015 1.015 0 00-1.65-.79L8.209 12.253a.189.189 0 01-.294-.08 2.538 2.538 0 00-4.466-.54 2.537 2.537 0 002.096 3.978 2.68 2.68 0 001.602-.568l3.845-3.116a.376.376 0 01.5.024l.553.542a.375.375 0 01.028.504L8.95 16.846a2.686 2.686 0 00-.568 1.6 2.54 2.54 0 002.693 2.55 2.545 2.545 0 002.377-2.847 2.542 2.542 0 00-1.63-2.07.188.188 0 01-.08-.294l9.035-11.132c.146-.18.226-.406.225-.638zM4.5 13.07a1.043 1.043 0 112.087-.002 1.043 1.043 0 01-2.086.002zm7.469 5.376a1.043 1.043 0 11-2.086.003 1.043 1.043 0 012.086-.003zm1.527-7.202a.374.374 0 01-.554.032l-.217-.214a.375.375 0 01.026-.56l2.536-2.055a.187.187 0 01.264.263l-2.055 2.534z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgTweezer);
export default ForwardRef;
